import { styled } from '@/stitches.config';

export const TableFootStyled = styled('tfoot', {
  backgroundColor: '$coolGray300',
});
